export function CustomerStep4Review({ formData, selectedType }) {
  const location = [formData.city, formData.state, formData.country].filter(Boolean).join(', ');
  const customerTypeLabel =
    formData.customer_type === 'other' ? formData.custom_type : selectedType?.label || '-';
  const enabledChannels = Object.entries(formData.telemetry_channels || {})
    .filter(([, v]) => v)
    .map(([k]) => k.replace('_', ' '));

  return (
    <div className="space-y-4">
      <p className="text-sm text-slate-600 dark:text-slate-400 mb-4">
        Review customer details before registration:
      </p>

      <div className="bg-slate-50 dark:bg-slate-700/50 rounded-lg p-4 space-y-3">
        <ReviewRow label="Customer Type" value={customerTypeLabel} />
        <ReviewRow label="Company Name" value={formData.company_name} />
        <ReviewRow label="Company Code" value={formData.company_code} mono />
        {formData.city && <ReviewRow label="Location" value={location} />}
        <ReviewRow label="Profile" value={formData.profile_type || 'CUSTOM'} />
        <ReviewRow
          label="Telemetry Channels"
          value={enabledChannels.length ? enabledChannels.join(', ') : 'none'}
        />
        <ReviewRow label="Admin User" value={formData.admin_name} />
        <ReviewRow label="Admin Email" value={formData.admin_email} last />
      </div>

      <div className="bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded-lg p-3">
        <p className="text-sm text-amber-700 dark:text-amber-400">
          <strong>Note:</strong> The admin user will receive login credentials and can access the Customer Ops Portal at{' '}
          <code className="bg-amber-100 dark:bg-amber-900/30 px-1.5 py-0.5 rounded text-xs">/ops/login</code>
        </p>
      </div>
    </div>
  );
}

function ReviewRow({ label, value, mono = false, last = false }) {
  return (
    <div className={`flex justify-between py-2 ${last ? '' : 'border-b border-slate-200 dark:border-slate-600'}`}>
      <span className="text-slate-500 dark:text-slate-400">{label}</span>
      <span className={`text-slate-900 dark:text-slate-100 ${mono ? 'font-mono' : ''}`}>{value}</span>
    </div>
  );
}
